<template>

    <footer class="card card-container py-3 my-4 footer ">
      <ul class="nav justify-content-center border-bottom pb-3 mb-3"></ul>
      <p class="text-center rf_texto ">© 2024 Deal Desk Systems</p>
      
    </footer>
</template>